<div (resized)="onResized($event)" class="filter-container">
    <mat-form-field (click)="openCompleteFilter()" style="margin-bottom: -1.25em" appearance="fill" class="filter-input-control">
        <mat-label>Búsqueda</mat-label>
        <mat-icon (click)="openCompleteFilter()" matPrefix>search</mat-icon>
        <input (click)="openCompleteFilter()" (keyup)="onKeyup($event.target.value)" autocomplete="off" matInput />
        <button matSuffix *ngIf="!completingFilter" (click)="completeFilter()" mat-icon-button>
      <mat-icon #entityDos>keyboard_arrow_down</mat-icon>
    </button>
    </mat-form-field>

    <div [hidden]="!completingFilter" [style.width.px]="widthExp" class="fixed mat-elevation-z1">
        <div #entity class="filter-content"></div>
        <div class="filter-footer">
            <button color="primary" (click)="search()" mat-flat-button type="button">
        Buscar
      </button>

            <button *ngIf="canCopyFilter" color="primary" (click)="copyFilter.emit()" mat-button type="button">
        <mat-icon>content_copy</mat-icon>
        Guardar Filtros
      </button>
        </div>
    </div>

    <mat-progress-bar class="progress-margin login-container" color="primary" *ngIf="loading" mode="indeterminate"></mat-progress-bar>
</div>
